import React, { JSX, useState } from 'react';
import { ButtonTypes } from '../Definitions';
import { colors, glyphs } from '../Styles';
import NewButton from './BaseComponents/newButton';

interface sliderProps {
  circlesPerPage?: number
  content: JSX.Element[];
}

export default function Slider({ content, circlesPerPage }: sliderProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const perPage = circlesPerPage ? circlesPerPage : 2;

  const [activePage, setActivePage] = useState(0);
  const totalPages = Math.ceil(content.length / perPage);

  const startIndex = activePage * perPage;
  const visibleContent = content.slice(startIndex, startIndex + perPage);

  const handleNext = () => {
    const nextPage = (activePage + 1) % totalPages;
    setActivePage(nextPage);
  };
  
  const handlePrev = () => {
    const prevPage = (activePage - 1 + totalPages) % totalPages;
    setActivePage(prevPage);
  };

  // #region | Navigation
  const prevBtn = (
    <NewButton
      content=""
      onClick={handlePrev}
      buttonType={ButtonTypes.textButton}
      startEnhancer={glyphs.Arrow({ rotate: 180, fillColor: colors.greyTertiary })}
    />
  );

  const nextBtn = (
    <NewButton
      content=""
      onClick={handleNext}
      buttonType={ButtonTypes.textButton}
      endEnhancer={glyphs.Arrow({ fillColor: colors.greyTertiary })}
    />
  );

  const dots = (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      {Array.from({ length: totalPages }, (_, i) => (
        <div key={i}
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            backgroundColor: i === activePage ? colors.greyTertiary : colors.greyLightSecondary,
            transition: 'background-color 0.3s'
          }}
        />
      ))}
    </div>
  );
  // #endregion

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between", width: "100%", gap: "10px"}}>
      <div style={{overflow: "visible", width: "100%"}}>
        <div style={{
          display: "flex",
          transition: "transform 0.3s ease",
          transform: `translateX(-${activePage * (100 / totalPages)}%)`,
          width: `${totalPages * 100}%`,
        }}>
          {Array.from({ length: totalPages }, (_, pageIndex) => {
            const start = pageIndex * perPage;
            const end = start + perPage;
            const pageContent = content.slice(start, end);

            if (pageContent.length === 0) return null;

            return (
              <div key={pageIndex} style={{
                width: `${100 / totalPages}%`,
                justifyContent: "center",
                display: "grid",
                gridTemplateColumns: `repeat(${perPage}, 160px)`,
                // gap: "30px",
                boxSizing: "border-box",
                flexGrow: 1,
              }}>
                {pageContent.map((content, i) => (
                  <React.Fragment key={i}>{content}</React.Fragment>
                ))}
              </div>
            );
          })}
        </div>
      </div>
      
      <div style={{ display: "flex", height: "18px", gap: "20px", alignItems: "center", borderTop: "2px solid "+colors.greyTertiary, width: "100%", maxWidth: perPage*120, justifyContent: "center", paddingTop: "10px", boxSizing: "border-box"}}>
        {prevBtn}
        {dots}
        {nextBtn}
      </div>
    </div>
  );
}
